export class IBusinessOperation {
    businessOperations: string;
    businessOperationQualifiers: string[];
}

